import { Typography, styled } from '@mui/material';
import { HTMLAttributes } from 'react';

import { Location } from '@cnx-saas/order-management';
import { LocationEmbeddedInput } from '@cnx-saas/common/generated';

export interface AutocompleteLocationOptionProps
  extends HTMLAttributes<HTMLLIElement> {
  location: Location | LocationEmbeddedInput;
}

export function AutocompleteLocationOption({
  location,
  ...props
}: AutocompleteLocationOptionProps) {
  return (
    <Root {...props}>
      <Typography>{location.company}</Typography>
      <Typography variant="body2" color="text.secondary">
        {location.address.street}, {location.address.zipCode}&nbsp;
        {location.address.city}, {location.address.country}
      </Typography>
    </Root>
  );
}

const Root = styled('li')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start !important',
});
